/**
 * Impersonation Banner
 *
 * Shown when a super_admin is logged in as another user.
 * Provides a way to stop impersonation and return to the admin account.
 */

import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { AlertTriangle, X } from "lucide-react";

export function ImpersonationBanner() {
  const navigate = useNavigate();
  const { user, impersonation, stopImpersonation } = useAuth();

  if (!impersonation?.active) {
    return null;
  }

  const handleStopImpersonation = () => {
    stopImpersonation();
    // Navigate back to admin users page
    navigate("/admin/users");
  };

  return (
    <div className="bg-purple-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center gap-3">
            <AlertTriangle size={18} className="text-purple-200" />
            <span className="text-sm font-medium">
              Du är inloggad som{" "}
              <span className="font-bold">{user?.email}</span>
              <span className="text-purple-200 ml-2">
                (impersonerad av {impersonation.impersonatorEmail})
              </span>
            </span>
          </div>
          <button
            onClick={handleStopImpersonation}
            className="inline-flex items-center gap-2 px-3 py-1 text-sm font-medium bg-white/20 hover:bg-white/30 rounded-lg transition-colors"
          >
            <X size={14} />
            Avsluta impersonation
          </button>
        </div>
      </div>
    </div>
  );
}
